import { Form } from "../Abstracts/Form";
import { EntityModalForm } from "../CRUDs/abstracts/mixins/EntityModalForm";
import { FormActions } from "../CRUDs/abstracts/mixins/FormActions";
import { Preloader } from "../Common/Preloader";
import { checkoutVerification } from "./checkoutVerification";

export class ConfirmBankAccountForm extends Form {

    constructor(bankAccount) {

        super('verify_bank_account-modal', `${bankAccount.urlRoot}/${bankAccount.id}/verify/confirm`, 'POST');

        console.log(this.form)
        this.submitBtn = bankAccount.urlRoot =='/reseller' ? document.getElementById(`#verify`) : this.form.querySelector(`#verify`);
        this.listners();

        Object.assign(ConfirmBankAccountForm.prototype, checkoutVerification);

        ConfirmBankAccountForm.prototype.collectData = function() {
            return FormActions.collectDataInForm(this.formId);
        }
    }

    async submit() {

        const preloader = new Preloader('verify_bank_account-modal', true);
        preloader.setMessage('Wait until bank is checking your data');
        preloader.open();

        const result = await fetch(this.actionUrl, {
            method: this.method,
            body: JSON.stringify(this.collectData()),
            headers: { 'Content-Type': 'application/json' }
        });

        preloader.close();

        if (result.ok) this.successCallback(result);
        else this.errorCallback(result);
    }

    async successCallback(result) {
        const formHTML = await result.json();
        $('#verify_bank_account-modal').modal('hide');
        $('.modal-backdrop').first().remove();

        EntityModalForm.pasteForm(formHTML.modal);
        $('#success_verification-modal').modal('show');

    }
    async errorCallback(result) {
        const response = await result.json();

        if (response.modal) {
            $('#verify_bank_account-modal').modal('hide');
            $('.modal-backdrop').first().remove();
            EntityModalForm.pasteForm(response.modal);
            $('#failed_verification-modal').modal('show');
        } else {
            this.form.querySelector('#attemts-count').innerText = response.attemts;
            this.form.querySelector('.failed-verification-message').classList.remove('d-none');
        }
    }

    listners() {
        super.listners();
    }

    static init(bankAccount) {
        return new ConfirmBankAccountForm(bankAccount);
    }
}
